<template>
  <BittsSimpleCollapse class="current-plan-collapse" title="Current Plan">
    <section v-if="platformFee" data-testid="connector-plan">
      <div>
        <span>Connector Plan</span>
        <p>{{ platformFee }}/{{ billingPeriod }}</p>
        <p class="text-sm pt-4">Includes 1 Full Access seat</p>
      </div>
      <p>{{ platformFee }}</p>
    </section>
    <section data-testid="full-access">
      <div>
        <span
          >{{ totalBoughtCoreSeats }} Full Access
          {{ totalBoughtCoreSeats == 1 ? 'seat' : 'seats' }}</span
        >
        <p>{{ seatCost }} per seat/{{ billingPeriod }}</p>
      </div>
      <p>{{ totalSeatCost }}</p>
    </section>
    <section v-if="salesSeatLimit" data-testid="sales">
      <div>
        <span
          >{{ salesSeatLimit }} Sales
          {{ salesSeatLimit == 1 ? 'seat' : 'seats' }}</span
        >
        <p>{{ salesSeatCost }} per seat/{{ billingPeriod }}</p>
      </div>
      <p>{{ totalSalesSeatCost }}</p>
    </section>
  </BittsSimpleCollapse>
</template>

<script setup lang="ts">
import { BittsSimpleCollapse } from '@crossbeam/bitts';

import { computed } from 'vue';

const {
  billingPeriod,
  coreSeatLimit,
  platformFee,
  salesSeatLimit,
  salesSeatCost,
  seatCost,
  totalSeatCost,
  totalSalesSeatCost,
} = defineProps<{
  billingPeriod: string;
  coreSeatLimit: number;
  salesSeatLimit?: number;
  platformFee: string;
  seatCost: string;
  salesSeatCost?: string;
  totalSeatCost: string;
  totalSalesSeatCost?: string;
}>();

const totalBoughtCoreSeats = computed(() => {
  if (!platformFee) return coreSeatLimit;
  return coreSeatLimit - 1; // Exclude the 1 Full Access Seat included in the platform fee
});
</script>

<style scoped lang="pcss">
.current-plan-collapse {
  @apply rounded-bts-md bg-white p-12;
}
section {
  @apply flex justify-between items-start py-16 border-b border-solid border-neutral-border;
  &:last-of-type {
    @apply border-none pb-4;
  }
}
span {
  @apply text-neutral-text-strong;
}
p {
  @apply text-neutral-text-weak;
}
</style>
